import React from 'react';

function StoolExaminationForm() {
  return (
    <div>
      <h2>StoolExaminationForm</h2>
    </div>
  );
}

export default StoolExaminationForm;
